import React from "react";
import { Box, Typography } from "@mui/material";
import { CheckCircleOutline as ActiveIcon } from "@mui/icons-material";

export default function StrategyCard({ option, selected, onSelect }) {
  const Icon = option.icon;
  return (
    <Box
      onClick={() => onSelect(option.value)}
      sx={{
        cursor: "pointer",
        borderRadius: 3,
        border: selected ? `2px solid ${option.color}` : "2px solid transparent",
        background: option.lightBg,
        "body[data-theme='dark'] &": { background: option.darkBg },
        p: 2,
        transition: "all 0.22s ease",
        position: "relative",
        overflow: "hidden",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: `0 8px 24px ${option.color}33`,
          border: `2px solid ${option.color}`,
        },
        boxShadow: selected ? `0 4px 16px ${option.color}44` : "none",
      }}
    >
      {selected && (
        <Box
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            width: 20,
            height: 20,
            borderRadius: "50%",
            background: option.gradient,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ActiveIcon sx={{ fontSize: 14, color: "#fff" }} />
        </Box>
      )}
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: 2,
          background: option.gradient,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 1.5,
        }}
      >
        <Icon sx={{ fontSize: 22, color: "#fff" }} />
      </Box>
      <Typography fontWeight={700} fontSize={13} color="var(--text-primary)" fontFamily="Poppins, sans-serif">
        {option.label}
      </Typography>
      {option.subtitle && (
        <Typography fontSize={11} color={option.color} fontFamily="Poppins, sans-serif" fontWeight={500} mb={0.5}>
          {option.subtitle}
        </Typography>
      )}
      <Typography fontSize={11} color="var(--text-secondary)" fontFamily="Poppins, sans-serif" sx={{ lineHeight: 1.5, whiteSpace: "normal" }}>
        {option.description}
      </Typography>
    </Box>
  );
}
